import analyticsMiddleware from './analytics'

export default [
  analyticsMiddleware,
]
